import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';

interface NoDataFoundProps {
  message?: string;
  icon?: React.ReactNode;
  centered?: boolean;
  py?: number;
}

export const NoDataFound: React.FC<NoDataFoundProps> = ({
  message = 'No data found.',
  icon,
  centered = true,
  py = 4,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: centered ? 'center' : 'flex-start',
        justifyContent: 'center',
        py,
        textAlign: centered ? 'center' : 'left',
      }}
    >
      {icon !== null && (
        <Box sx={{ mb: 1.5, color: theme.palette.text.disabled, opacity: 0.5 }}>
          {icon || <InboxOutlined sx={{ fontSize: 48 }} />}
        </Box>
      )}
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        {message}
      </Typography>
    </Box>
  );
};

export default NoDataFound;
